import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { useGarageStore } from '@/modules/FindGarage'
import { useInvalidateUnfinishedRecords } from '@/pages/UnfinishedRecords/api/useInvalidateUnfinishedRecords'
import { ROUTES } from '../routes'

export const useMileageClerkNavigation = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { garage, clearGarage } = useGarageStore()
    const { invalidateUpdatedRecords } = useInvalidateUnfinishedRecords()

    const backCallback = useMemo(() => {
        if (!garage) {
            return null
        }

        if (garage && location.pathname === ROUTES.HOME) {
            return async () => {
                clearGarage()
                invalidateUpdatedRecords()
            }
        }

        if ([ROUTES.VEHICLE_ALLOCATION, ROUTES.DISRUPTIONS].includes(location.pathname)) {
            return () => navigate(ROUTES.HOME)
        }

        if (location.pathname === ROUTES.SHARED_LOG) {
            return () => navigate(ROUTES.HOME)
        }
    }, [location, garage])

    const paths = useMemo(() => {
        if (garage && location.pathname === ROUTES.HOME) {
            return ['Garages', garage.name]
        }

        if (garage && location.pathname === ROUTES.VEHICLE_ALLOCATION) {
            return ['Garages', garage.name, 'Vehicle allocation']
        }

        if (garage && location.pathname === ROUTES.DISRUPTIONS) {
            return ['Garages', garage.name, 'Disruptions']
        }

        if (garage && location.pathname === ROUTES.FLAGGED) {
            return ['Garages', garage.name, 'Flagged records']
        }

        if (garage && location.pathname === ROUTES.SHARED_LOG) {
            return ['Controller logs', garage.name]
        }

        return []
    }, [garage, location])

    return {
        backCallback,
        paths,
    }
}
